import { useEffect } from 'react';
import {
  useLocation, useNavigate,
} from 'react-router-dom';
import { useIsUserSignedInSelector } from '~/store/userData/userData.selectors';

export const useNavigateAfterLogin = (isEnabled = true) => {
  const navigate = useNavigate();
  const isUserSignedIn = useIsUserSignedInSelector();
  const { state } = useLocation();

  useEffect(() => {
    if (isEnabled && isUserSignedIn) {
      // replace the sign in page in the history: going Back to a used SSO callback or verification link
      // would run it again and fail, as its one time token is already consumed
      navigate(state?.from ?? '/', { replace: true });
    }
  }, [navigate, isEnabled, isUserSignedIn, state?.from]);
};
